import styled from "styled-components";
import {Select} from "../../../basic-ui-components/form/select.component";

export const DropDownBox = styled(Select)`
    font-size: 14px;
`